import { joinURLPath } from '@sigma-frontend-libs/commons'

import { generateServices, globalErrorHandler, request, services, tableHeaderParser } from '@/utils'

import render from './render'

const $gt = new Date()
$gt.setHours(0, 0, 0, 0)
$gt.setDate(1)
const $lt = new Date()
$lt.setMilliseconds(0)
$lt.setSeconds(0)

export default {
  name: 'Referrals',

  mixins: [
    generateServices({
      name: services.billings,
      get: false,
      find: {
        defaultFilter: {
          createdAt: {
            $gt,
            $lt
          },
          OwnerId: undefined,
          $scope: [ 'referral' ]
        }
      },
      create: false,
      update: false,
      remove: false
    })
  ],

  props: {
    OwnerId: {
      type: String
    }
  },

  data() {
    return {
      loading: false,

      lastMonthSum: 0,
      referralCode: ''
    }
  },

  computed: {
    headers() {
      return tableHeaderParser.call(this, [
        {
          title: 'referral.headers.referral',
          value: 'referrer',
          align: 'left',
          class: 'pl-2 pr-2'
        },
        {
          title: 'referral.headers.amount',
          value: 'amount',
          align: 'right',
          class: 'pl-2 pr-2'
        },
        {
          title: 'referral.headers.date',
          value: 'createdAt',
          align: 'right',
          class: 'pl-2 pr-2'
        }
      ])
    },
    totalAmount() {
      if (this.restData[services.billings].find.pagination.total) {
        return this.restData[services.billings].find.data.reduce((sum, { amount }) => {
          return sum + parseFloat(amount)
        }, 0)
      }
    }
  },

  mounted() {
    this.restData[services.billings].find.filter.OwnerId = this.OwnerId || this.account.id
    this.getSumAndReferralCode()
  },

  methods: {
    async getSumAndReferralCode() {
      try {
        this.loading = true
        const result = await request.get(joinURLPath('users', this.OwnerId || this.account.id), undefined, {
          $scope: [ 'full' ]
          // $scope: [ 'referral' ] // TODO: uncomment when backend will be ready
        })
        this.referralCode = result.referralCode
        // this.lastMonthSum = result.$referral.lastMonthSum // TODO: uncomment when backend will be ready
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
